//用户组
import UserGroups from "@/views/systerm/userConfig/userGroup/UserGroups.vue"; //
import UserGroupItem from "@/views/systerm/userConfig/userGroup/UserGroupItem.vue"; //用户组配置首页
// import UserGroupInfo from '@/views/systerm/userConfig/userGroup/UserGroupInfo.vue' //用户组配置
import CreateUserGroup from "@/views/systerm/userConfig/userGroup/CreateUserGroup.vue"; //用户组创建

import UserGroupUsers from "@/views/systerm/userConfig/userGroup/UserGroupUsers.vue"; //
import UserGroupHistory from "@/views/systerm/userConfig/userGroup/UserGroupHistory.vue"; //
import UserGroupAssignment from "@/views/systerm/userConfig/userGroup/UserGroupAssignment.vue"; //

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

export const UserGroupsPage = [
  {
    path: "/UserGroupItem",
    // name:UserGroupItem,
    component: UserGroupItem,
    meta: {},
    children: [
      {
        path: "/UserGroupInfo",
        // name:UserGroupInfo,
        component: PageInfo,
        meta: {},
      },
      {
        path: "/UserGroupUsers",
        // name:UserGroupUsers,
        component: UserGroupUsers,
        meta: {},
      },
      {
        path: "/UserGroupHistory",
        component: UserGroupHistory,
        // name:UserGroupHistory,
        meta: {},
      },
      {
        path: "/UserGroupRelationship",
        component: Relationship,
        // name:UserGroupRelationship,
        meta: {},
      },
      {
        path: "/UserGroupAttachment",
        component: ItemAttachment,
        // name:UserGroupAttachment,
        meta: {},
      },
      {
        path: "/UserGroupAttachment2",
        component: ItemAttachment,
        // name:UserGroupAttachment,
        meta: {},
      },
      {
        path: "/UserGroupAssignment",
        component: UserGroupAssignment,
        // name:UserGroupAssignment,
        meta: {},
      },
    ],
  },
  {
    path: "/UserGroups",
    // name:UserGroups,
    component: UserGroups,
  },
  {
    path: "/createUserGroup",
    component: CreateUserGroup,
  },
];
